import { createAction } from 'redux-actions';
import {
  KPI_LANDING_ZONE_REQUEST,
  KPI_LANDING_ZONE_SUCCESS,
  KPI_LANDING_ZONE_FAILURE,
  CAMPAIGNS_LANDING_ZONE_REQUEST,
  CAMPAIGNS_LANDING_ZONE_SUCCESS,
  CAMPAIGNS_LANDING_ZONE_FAILURE,
  CAMPAIGN_LANDING_ZONE_FAILURE,
  CAMPAIGN_LANDING_ZONE_SUCCESS,
  CAMPAIGN_LANDING_ZONE_REQUEST,
  RESET_CAMPAIGN_SUCCESS,
} from './constants';

export const getKpisForLandingZone = createAction(KPI_LANDING_ZONE_REQUEST);
export const getKpisForLandingZoneSuccess = createAction(KPI_LANDING_ZONE_SUCCESS);
export const getKpisForLandingZoneFailure = createAction(KPI_LANDING_ZONE_FAILURE);

export const getCampaignsForLandingZone = createAction(CAMPAIGNS_LANDING_ZONE_REQUEST);
export const getCampaignsForLandingZoneSuccess = createAction(CAMPAIGNS_LANDING_ZONE_SUCCESS);
export const getCampaignsForLandingZoneFailure = createAction(CAMPAIGNS_LANDING_ZONE_FAILURE);

export const getCampaignForLandingZone = createAction(CAMPAIGN_LANDING_ZONE_REQUEST);
export const getCampaignForLandingZoneSuccess = createAction(CAMPAIGN_LANDING_ZONE_SUCCESS);
export const getCampaignForLandingZoneFailure = createAction(CAMPAIGN_LANDING_ZONE_FAILURE);

export const resetCampaignSuccess = createAction(RESET_CAMPAIGN_SUCCESS);
